<script setup>
import { useAuthStore } from "@/stores/auth";
import { useMiscStore } from "@/stores/misc";
import { MapPinIcon, RssIcon } from "@heroicons/vue/16/solid";

const props = defineProps({
    creator: {
      default: null,
      type: Object
    },
  }),
  miscStore =  useMiscStore(),
  toggleFollowing = (id) => {
    if (useAuthStore().guest) {
      return alert('You need to be logged in to perform this action');
    }
    miscStore.toggleFollowing(id).then(() => {
      if (miscStore.error) {
        return alert(miscStore.error);
      }
    })
  };
</script>

<template>
  <div class="mb-3">
    <div class="grid grid-cols-1 lg:grid-cols-8 gap-4">
      <div class="col-span-1 md:col-span-2 rounded-xl">
        <router-link
          class="card-link mx-auto md:mx-0"
          :to="`/users/${props.creator?.id}/businesses`"
        >
          <img
            v-if="!props.creator?.profile?.avatar_status"
            :src="props.creator?.profile?.avatar"
            :alt="props.creator?.name"
            class="rounded-xl shadow h-full w-full object-cover"
            decoding="async"
            importance="low"
            loading="lazy"
          >
          <img
            v-else
            :src="props.creator?.email"
            :alt="props.creator?.name"
            class="rounded-xl shadow h-full w-full object-cover"
            decoding="async"
            importance="low"
            loading="lazy"
          >
        </router-link>
      </div>
      <div class="cols-span-1 md:col-span-6 bg-white p-4 md:text-left rounded-xl ay-shadow drop-shadow">
        <div class="">
          <div class="mb-4">
            <h4 class="mb-2 h5 text-sm">
              <!-- <span class="block text-gray-400 mb-2">Added by</span> -->
              <router-link
                class="text-gray-600 font-semibold uppercase card-link"
                :to="`/users/${ props.creator?.id }/businesses`"
              >
                {{ props.creator?.name }}
              </router-link>
            </h4>
            <h5 class="h6 font-medium mb-2 text-xs">
              <router-link
                class="text-gray-400 card-link"
                :to="`/users/${ props.creator?.id }/businesses`"
              >
                <span class="capitalize">
                  @{{ props.creator?.name }}
                </span>
              </router-link>
            </h5>
          </div>
          <div class="text-red-400">
            <p class="mb-4 h6 flex items-center">
              <MapPinIcon class="h-4 w-4 block" />
              <span class="font-medium block text-xs">{{ props.creator?.profile?.location }}</span>
            </p>
          </div>
          <div class="w-100">
            <p
              class="text-gray-500 text-xs font-medium mb-4 md:mb-0 pt-md-2"
            >
              {{ props.creator?.profile?.bio }}
            </p>
          </div>
        </div>
        <button
          v-if="useAuthStore().user?.id !== props.creator?.id"
          id="follow-btn"
          data-user-id="{{ props.creator?.id }}"
          class="px-3 py-2 mt-4 border flex justify-between text-white text-sm  rounded-lg font-semibold shadow transition-all duration-500"
          :class="{
            'bg-green-600 hover:bg-green-500' : !props.creator?.authenticatedUserIsFollowing,
            'bg-red-600 hover:bg-red-500' : props.creator?.authenticatedUserIsFollowing
          }"
          @click="toggleFollowing(props.creator?.id)"
        >
          <RssIcon class="h-4 w-4 inline mr-0.5" />
          <span v-if="!props.creator?.authenticatedUserIsFollowing">Follow</span>
          <span v-else>Unfollow</span>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
